import { jsx as _jsx } from "react/jsx-runtime";
export function ChartDrillList({ drills, label }) {
    if (!drills.length)
        return null;
    return (_jsx("ul", { className: "cdl-drills", "aria-label": label, children: drills.map((d) => (_jsx("li", { children: _jsx("button", { type: "button", className: "cdl-drills__btn", onClick: d.onSelect, children: d.label }) }, d.key))) }));
}
export default ChartDrillList;
